import { client } from '~/apollo-client';
import { GENERATE_TEXT_MUTATION } from '~/ai/state/contentGeneration/generateTextMutation';
import { REPHRASE_TEXT_MUTATION } from '~/ai/state/contentGeneration/rephraseTextMutation';
import { SUMMARIZE_TEXT_MUTATION } from '~/ai/state/contentGeneration/summarizeTextMutation';
import { EXPAND_TEXT_MUTATION } from '~/ai/state/contentGeneration/expandTextMutation';

export async function getGeneratedText({
  organizationId,
  prompt,
  isHighlighted,
  action,
}: {
  organizationId: string;
  prompt: string;
  isHighlighted: boolean;
  action: string;
}): Promise<string> {
  let generatedContent;

  const actionsMap = {
    generateText: GENERATE_TEXT_MUTATION,
    rephraseText: REPHRASE_TEXT_MUTATION,
    summarizeText: SUMMARIZE_TEXT_MUTATION,
    expandText: EXPAND_TEXT_MUTATION,
  };

  const cta = isHighlighted
    ? `publish-ideas-ideasEditor-${action}Highlighted-1`
    : `publish-ideas-ideasEditor-${action}-1`;

  await client
    .mutate<
      {
        action: { suggestions?: { content: string }[]; code?: string };
      },
      {
        organizationId: string;
        config: { prompt: string; cta: string };
      }
    >({
      mutation: actionsMap[action] || GENERATE_TEXT_MUTATION,
      variables: {
        organizationId,
        config: {
          prompt,
          cta,
        },
      },
    })
    .then((response) => {
      // handles a returned error
      if (response.data?.[action]?.code) {
        const errorMessage =
          response.data?.[action]?.code === 'InsuffiecientTokens'
            ? "Whoops! Looks like you don't have any tokens left."
            : 'Whoops! We are unable to generate content at this time. Please try again.';
        throw new Error(errorMessage);
      } else {
        // handles a successful response
        const generatedText = response.data?.[action].suggestions;

        /**
         * for now we are just returning 1 object with a content property
         * but when we return more complex types, we will need to handle it
         * differently */
        generatedContent = generatedText && generatedText[0].content;
      }
    })
    .catch(() => {
      const errorMessage =
        'Whoops! We are unable to generate content at this time. Please try again.';

      throw new Error(errorMessage);
    });
  return generatedContent;
}
